import {
  ChangePasswordErrorTypes,
  FirebaseAuthErrorCode,
  ReauthErrorKind,
} from '@griply/types';
import { LoginErrorTypes } from 'shared/types/login-form';
import { ResetPasswordErrorTypes } from 'shared/types/reset-password-form';

// Outcomes a form already renders; an `unknown` kind is reported where it is thrown.
const expectedMutationErrors = new Set<string>([
  LoginErrorTypes.WrongCombination,
  ChangePasswordErrorTypes.WrongPassword,
  ChangePasswordErrorTypes.WeakPassword,
  ReauthErrorKind.WrongPassword,
  ReauthErrorKind.Cancelled,
  ResetPasswordErrorTypes.InvalidCode,
]);

// A used or expired email link, raw from applyActionCode (verify-email) or verifyPasswordResetCode (reset).
const expectedFirebaseCodes = new Set<string>([
  FirebaseAuthErrorCode.InvalidActionCode,
  FirebaseAuthErrorCode.ExpiredActionCode,
]);

export const isExpectedMutationError = (error: unknown): boolean => {
  const { kind, code } = (error ?? {}) as { kind?: unknown; code?: unknown };

  if (typeof code === 'string' && expectedFirebaseCodes.has(code)) {
    return true;
  }

  return typeof kind === 'string' && expectedMutationErrors.has(kind);
};
